import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import $ from "jquery";
import SideMenu from "../Pages/SideMenu";
import Footer from "../Pages/Footer";
import Header from "../Pages/Header";
import Logout from "../Pages/Logout";
import { strings } from "../Utilities/strings";
// for Sidebar And Navbar
import Search from "../images/search.png";
//for fontawesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faPlus,
  faEye,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
//for data table
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "@fortawesome/fontawesome-svg-core/styles.css";

//for modal
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Modal } from "react-bootstrap";
import { addRoleMaster, getRoleMaster } from "../Utilities/URLCONSTANTS";
// import {Oval as Loader} from 'react-loader-spinner';
import Loader from "../Utilities/Loader";
// import ViewIcon from "../images/viewIcon.png";
import Eye_Icon from "../images/Eye_Icon.svg";
import closedProducts from "../images/closed-products.png";
import user from "../images/user.png";
import productrequestImage from "../images/closed-products.png";
import issuedProducts from "../images/issued-products.png";
import PendingProducts from "../images/Pending_products.png";
import {
  getAllRecievedRequestsFarmOperation,
  requestAcceptReject, getMasters
} from "../Utilities/URLCONSTANTS";
import { GetApiHeaders } from "../Utilities/NetworkUtilities";
import { USER_PROFILE } from "../Utils";
import moment from "moment";
import * as XLSX from "xlsx";
import { CustomDatePickerInput, customstyles, customStyles } from "../Utilities/utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import {
  HiMiniArrowsUpDown,
  HiMiniArrowUp,
  HiMiniArrowDown,
} from "react-icons/hi2";
import Pagination from "../Utilities/Pagination";

//UnitMeasureMaster

//UnitMeasureMaster
const RequestFarmOperation1 = () => {
  const [submitResponse, setsubmitResponse] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showResponsePopup, setShowResponsePopup] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupText, setPopupText] = useState(
    "Do you want to close Unit Measure Master"
  );
  const [loading, setLoading] = useState(false);
  const [showDetails, setShowDetails] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showMsg, setShowMsg] = useState("false");
  const [showWarningPopup, setShowWarningPopup] = useState(false);
  const [data, setData] = useState([]);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [getAccName, setGetAccName] = useState([]);
  // const [remark, setRemark] = useState();
  const [remark, setRemark] = useState([]);
  const [errRemark, setErrRemark] = useState([]);
  // const [errRemark, setErrRemark] = useState("");
  const [selectedItem, setSelectedItem] = useState();
  const [selectedItemIndex, setSelectedItemIndex] = useState();
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [totalItems, setTotalItems] = useState();
  const [loaderImage, setLoaderImage] = useState(
    require("../images/fo_loader.gif")
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  // const [estDate, setEstDate] = useState("");
  const [estDate, setEstDate] = useState([]);
  // const [errEstimated, setErrEstimated] = useState("");
  const [errEstimated, setErrEstimated] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [getMasterData, setGetMasterData] = useState([])
  // const [cropFunctionId, setCropFunctionId] = useState()

  const handleCancel_new = () => {
    //no
    // alert("handleCancel");
    setShowModal(true);
    setShowPopup(true);
  };
  const closeWarning = () => {
    setShowWarningPopup(true);
    // window.location.reload();
  };
  const handleCancel = () => {
    setShowPopup(false);
    setShowModal(true);
    setShowMsg(true);
    // window.location.reload();
  };
  const handleClose = () => {
    //yes
    // alert("handleCancel");
    // setPopupText('Custom popup text here');
    setShowPopup(false);
    setShowModal(false);
    window.location.reload();
  };
  const handleModalOpen = (item, index) => {
    setShowModal(true);
    setSelectedItem(item);
    setSelectedItemIndex(index);
  };

  const handleRemark = (e) => {
    setRemark(e.target.value);
    if (e.target.value) {
      setErrRemark("");
    }
  };
  //for data table
  const tableRef = useRef(null);
  useEffect(() => {
    // Check if DataTable is already initialized
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      // Destroy the existing DataTable instance
      $(tableRef.current).DataTable().destroy();
    }
    // Initialize the DataTable
    $(tableRef.current).DataTable({
      ordering: false, // Disable sorting
    });
    fetchData();
    const userProfileJSON = sessionStorage.getItem(USER_PROFILE);
    setGetAccName(JSON.parse(userProfileJSON));
    console.log("User Profile:", JSON.parse(userProfileJSON));
  }, []);


  useEffect(() => {
    if (data != null && data != undefined) {
      //  const totalItems = data.length;
      setFilteredData(data);
      setTotalItems(data.length);
    }
  }, [data]);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const filteredDat = data.filter((item) => {
    return selectedLocation === "" || item.subSiteName === selectedLocation;
  });



  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentItems = filteredDat.slice(indexOfFirstItem, indexOfLastItem);

  const handleItemsPerPageChange = (e) => {
    const selectedValue = parseInt(e.target.value);
    setItemsPerPage(selectedValue);
    setCurrentPage(1); // Reset to the first page when changing items per page.
  };

  const pageNumbers = [];
  for (
    let i = Math.max(2, currentPage - 1);
    i <= Math.min(Math.ceil(totalItems / itemsPerPage) - 1, currentPage + 1);
    i++
  ) {
    pageNumbers.push(i);
  }


  const handlePageClick = (page) => {
    const totalPages = Math.ceil(sortedData.length / itemsPerPage);
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const fetchGetMaster = async () => {
    const getData = getMasters;
    const headers = await GetApiHeaders();
    try {
      const responseGetData = await axios.post(getData, null, { headers });
      setGetMasterData(responseGetData.data.response.storeLocation)
    } catch (err) {
      console.log("getError", err);
    }
  };
  useEffect(() => {
    fetchGetMaster()
  }, [])
  const handleresponse = () => {
    setShowResponsePopup(false);
    setShowWarningPopup(false);
    setShowPopup(false);
    setShowModal(false);
    window.location.reload();
  };
  const handleModalClose = () => {
    setShowPopup(false);
    setShowModal(false);
    setShowWarningPopup(false);
    window.location.reload();
  };
  const toggleDetails = (index) => {
    setSelectedRowIndex(index === selectedRowIndex ? null : index);
  };

  const fetchData = async () => {
    const fetchApi = getAllRecievedRequestsFarmOperation;
    const headers = await GetApiHeaders();

    try {
      setIsLoading(true);
      const response = await axios.get(fetchApi, { headers });
      console.log("farmOperation Get", response);

      setData(response.data.response.receivedRequests);
      setIsLoading(false);
    } catch (err) {
      console.group(err);
    }
  };

  const handleApprove = async (index) => {

    const updatedErrors = [...errEstimated];
    if (!estDate[index]) {
      updatedErrors[index] = "Please select an Estimated Date";
      setErrEstimated(updatedErrors);
      return;
    }

    updatedErrors[index] = "";
    setErrEstimated(updatedErrors);

    if (!remark) {
      setErrRemark("Please Enter a Remarks");
      return;
    }
    const acceptApi = requestAcceptReject;
    const headers = await GetApiHeaders();
    const postData = {
      acceptorName: getAccName.firstName + " " + getAccName.lastName,
      cropFunctionId: data[index].cropFunctionId,
      requesterUserId: data[index].requesterUserId,
      mainSiteId: data[index].mainSiteId,
      subSiteName: data[index].subSiteName,
      subSiteId: data[index].subSiteId,
      requiredDate: data[index].requiredDate,
      submittedDate: data[index].submittedDate,
      serverRequestId: data[index].serverRequestId,
      acceptorMobileNo: data[index].acceptorMobileNo,
      plotAcreageName: data[index].plotAcreageName,
      typeOfOperationName: data[index].typeOfOperationName,
      requesterName: data[index].requesterName,
      plotNoLocationName: data[index].plotNoLocationName,
      requesterMobileNo: data[index].requesterMobileNo,
      mainSiteName: data[index].mainSiteName,
      requesterRemarks: data[index].requesterRemarks,
      actualCropId: data[index].actualCropId,
      serverRecordId: data[index].serverRecordId,
      acceptorUserId: getAccName.userId,
      plantedArea: data[index].plantedArea,
      actualCropName: data[index].actualCropName,
      typeOfOperationId: data[index].typeOfOperationId,
      plotAcreageId: data[index].plotAcreageId,
      cropFunctionName: data[index].cropFunctionName,
      plotNoLocationId: data[index].plotNoLocationId,
      status: "Approved",
      acceptorRemarks: remark,
      estDate: estDate,

    };
    try {
      if (estDate && remark) {
        setIsLoading(true);
        const response = await axios.post(acceptApi, postData, { headers });
        console.log("Farm operation Accept", response);
        setsubmitResponse(response.data.message);
        setShowModal(false);
        setShowResponsePopup(true);
        setIsSubmitted(true);
        setIsLoading(false);
      }
    } catch (err) {
      console.log("error farm Operation", err);
    }
  };

  const handleReject = async (selectedItem, selectedItemIndex) => {
    const acceptApi = requestAcceptReject;
    const headers = await GetApiHeaders();
    const postData = {
      acceptorName: getAccName.firstName + " " + getAccName.lastName,
      cropFunctionId: data[selectedItemIndex].cropFunctionId,
      requesterUserId: data[selectedItemIndex].requesterUserId,
      mainSiteId: data[selectedItemIndex].mainSiteId,
      subSiteName: data[selectedItemIndex].subSiteName,
      subSiteId: data[selectedItemIndex].subSiteId,
      requiredDate: data[selectedItemIndex].requiredDate,
      submittedDate: data[selectedItemIndex].submittedDate,
      serverRequestId: data[selectedItemIndex].serverRequestId,
      acceptorMobileNo: data[selectedItemIndex].acceptorMobileNo,
      plotAcreageName: data[selectedItemIndex].plotAcreageName,
      typeOfOperationName: data[selectedItemIndex].typeOfOperationName,
      requesterName: data[selectedItemIndex].requesterName,
      plotNoLocationName: data[selectedItemIndex].plotNoLocationName,
      requesterMobileNo: data[selectedItemIndex].requesterMobileNo,
      mainSiteName: data[selectedItemIndex].mainSiteName,
      requesterRemarks: data[selectedItemIndex].requesterRemarks,
      actualCropId: data[selectedItemIndex].actualCropId,
      serverRecordId: data[selectedItemIndex].serverRecordId,
      acceptorUserId: getAccName.userId,
      plantedArea: data[selectedItemIndex].plantedArea,
      actualCropName: data[selectedItemIndex].actualCropName,
      typeOfOperationId: data[selectedItemIndex].typeOfOperationId,
      plotAcreageId: data[selectedItemIndex].plotAcreageId,
      cropFunctionName: data[selectedItemIndex].cropFunctionName,
      plotNoLocationId: data[selectedItemIndex].plotNoLocationId,
      status: "Rejected",
      acceptorRemarks: remark,
      estDate: estDate,

    };
    try {
      if (remark) {
        setIsLoading(true);
        const response = await axios.post(acceptApi, postData, { headers });
        console.log("Farm operation Accept", response);
        setsubmitResponse(response.data.message);
        setShowModal(false);
        setShowResponsePopup(true);
        setErrRemark("");
        setIsSubmitted(true);
        setIsLoading(false);
      } else {
        setErrRemark("Please Enter Reamarks");
        setIsSubmitted(false);
      }
    } catch (err) {
      console.log("error farm Operation", err);
      setIsSubmitted(false);
    }
  };
  const handleClear = () => {
    setSearchTerm("");
  };

  const handleDateChange = (e, index) => {
    const updatedDates = [...estDate];
    updatedDates[index] = e.target.value;
    setEstDate(updatedDates);

    if (e.target.value) {
      const updatedErrors = [...errEstimated];
      updatedErrors[index] = "";
      setErrEstimated(updatedErrors);
    }
  };
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  const sortedData = [...filteredDat].sort((a, b) => {
    if (!sortConfig.key) return 0;

    const aValue = a[sortConfig.key];
    const bValue = b[sortConfig.key];

    if (!isNaN(aValue) && !isNaN(bValue)) {
      return sortConfig.direction === "asc"
        ? aValue - bValue
        : bValue - aValue;
    }

    const aString = (aValue ?? "").toString().toLowerCase();
    const bString = (bValue ?? "").toString().toLowerCase();

    if (aString < bString)
      return sortConfig.direction === "asc" ? -1 : 1;
    if (aString > bString)
      return sortConfig.direction === "asc" ? 1 : -1;

    return 0;
  });

  // Handle column sorting
  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === "asc" ? "desc" : "asc",
    }));
  };


  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <HiMiniArrowsUpDown className="ms-1" size={16} style={{ cursor: "pointer" }} />;
    }
    return sortConfig.direction === "asc" ? (
      <HiMiniArrowUp className="ms-1" size={16} style={{ cursor: "pointer" }} />
    ) : (
      <HiMiniArrowDown className="ms-1" size={16} style={{ cursor: "pointer" }} />
    );
  };
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);
  const options = getMasterData?.map(item => ({
    value: item.name,
    label: item.name,
  }));


  return (
    <body id="page-top">
      {/*  <!-- Page Wrapper --> */}
      <div id="wrapper">
        {/*  <!-- Sidebar --> */}
        <SideMenu />
        {/*  <!-- End of Sidebar --> */}

        {/*  <!-- Content Wrapper --> */}
        <div id="content-wrapper" className="d-flex flex-column">
          {/*  <!-- Main Content --> */}
          <div id="content">
            {/*  <!-- Topbar --> */}
            <Header />
            {/* ...Content Start... */}
            <div>
              <div className="container-fluid">
                <h5 className="Roles_text">Farm Operations</h5>
                <div>
                  <h5 className="mb-0 Sub_role_text"> Requests</h5>
                </div>
                <div className="card border-0">
                  <div className="card-body pt-0 pl-1">
                    <div className="d-flex justify-content-between">
                    </div>
                    <div className="mcrc_hrline "></div>
                    <div>
                      <div
                        className="card flex-grow-1 "
                        style={{
                          border: "1px solid #0000001A",
                          boxShadow: "0 0.1rem 0.3rem rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <div className="card-body " style={{ padding: "20px" }}>
                          <div
                            className="d-flex justify-content-between align-items-center"
                            style={{ paddingBottom: 20 }}
                          >
                            <div className="d-flex align-items-center">
                              <label className="mr-1">Show </label>
                              <Select
                                options={[
                                  { value: 10, label: '10' },
                                  { value: 20, label: '20' },
                                  { value: 50, label: '50' },
                                ]}
                                value={{
                                  value: itemsPerPage,
                                  label: String(itemsPerPage),
                                }}
                                onChange={(selected) => {
                                  setItemsPerPage(selected.value);
                                  setCurrentPage(1);
                                }}
                                isSearchable={false}
                                styles={customstyles}
                              />
                              &nbsp;
                              <label> Entries</label>
                            </div>
                            <div className="d-flex align-items-center">
                              <div style={{ position: "relative" }}>

                                <Select
                                  options={options}
                                  value={options.find(opt => opt.value === selectedLocation)}
                                  onChange={(selected) =>
                                    setSelectedLocation(selected?.value || '')
                                  }
                                  styles={customStyles}
                                  placeholder="Select Sub Site"
                                  isSearchable={false}
                                />
                              </div>
                              &nbsp;
                            </div>
                          </div>
                          <Table className="table table-bordered  table-striped Content_data_table ">
                            <Thead>
                              <Tr>
                                <Th className="text-center">S.No</Th>
                                <Th
                                  className="text-center"
                                  onClick={() => handleSort("serverRequestId")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Request Id
                                    {renderSortIcon("serverRequestId")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center"
                                  onClick={() => handleSort("requesterName")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Requester Name
                                    {renderSortIcon("requesterName")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center"
                                  onClick={() => handleSort("requesterMobileNo")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Mobile No
                                    {renderSortIcon("requesterMobileNo")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center"
                                  onClick={() => handleSort("mainSiteName")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Main Site
                                    {renderSortIcon("mainSiteName")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center"
                                  onClick={() => handleSort("subSiteName")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Sub Site
                                    {renderSortIcon("subSiteName")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center"
                                  onClick={() => handleSort("SubmitedDate")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Submitted Date & Time
                                    {renderSortIcon("SubmitedDate")}
                                  </span>
                                </Th>

                                <Th className="text-center">Action</Th>
                              </Tr>
                            </Thead>
                            {currentItems.length === 0 ? ( // Check if no data is found
                              <Tr>
                                <Td
                                  colSpan={8}
                                  className="text-center "
                                  style={{ padding: "17%" }}
                                >
                                  Data is not available
                                </Td>
                              </Tr>
                            ) : (
                              currentItems.map((item, index) => {
                                var newDateFormat = moment(
                                  item.requiredDate
                                ).format("DD-MMM-YYYY ");
                                var SubmitedDate = moment(
                                  item.submittedDate
                                ).format("DD-MMM-YYYY hh:mm:ss A ");
                                return (
                                  <Tbody>
                                    <Tr key={index}>
                                      <Td className="text-left">{(currentPage - 1) * itemsPerPage + index + 1}</Td>
                                      <Td className="text-left">
                                        {item.serverRequestId}
                                      </Td>
                                      <Td className="text-left">
                                        {item.requesterName}
                                      </Td>
                                      <Td className="text-left">
                                        {item.requesterMobileNo}
                                      </Td>
                                      <Td className="text-left">
                                        {item.mainSiteName}
                                      </Td>
                                      <Td className="text-left">
                                        {item.subSiteName}
                                      </Td>
                                      <Td className="text-left">
                                        {SubmitedDate}
                                      </Td>

                                      <Td
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >

                                        <div>
                                          <img
                                            src={Eye_Icon}
                                            alt="Details"
                                            className="eyeicon mr-1 "
                                            title="Details"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              toggleDetails(index);
                                            }}
                                          />
                                        </div>
                                      </Td>
                                    </Tr>
                                    {selectedRowIndex === index && (
                                      <Tr>
                                        <Td style={{ padding: 24 }} colSpan="9">
                                          <div className="request-card">
                                            <div style={{ fontSize: 14, width: "100%", }} className="ProductNameForRandM d-flex" >
                                              <span className=" mt-3" style={{ width: '33.4%', }}>
                                                <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                  PlotNo/Location Name
                                                </span>
                                                <span  >  :&nbsp;
                                                </span>
                                                <span style={{ width: '55%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{item.plotNoLocationName}</span>
                                              </span>
                                              <span className=" mt-3" style={{ width: '33.4%', }}>
                                                <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                  Plot Acreage Name
                                                </span>
                                                <span  >  :&nbsp;
                                                </span>
                                                <span style={{ width: '55%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{item.plotAcreageName}</span>
                                              </span>
                                              <span className=" mt-3" style={{ width: '33.4%', }}>
                                                <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                  Planted Area
                                                </span>
                                                <span  >  :&nbsp;
                                                </span>
                                                <span style={{ width: '55%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{item.plantedArea}</span>
                                              </span>
                                            </div>

                                            <div style={{ fontSize: 14, width: "100%", }} className="ProductNameForRandM d-flex" >
                                              <span className=" mt-3" style={{ width: '33.4%', }}>
                                                <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                  Crop in Field
                                                </span>
                                                <span  >  :&nbsp;
                                                </span>
                                                <span style={{ width: '55%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{item.actualCropName}</span>
                                              </span>

                                              <span className=" mt-3" style={{ width: '33.4%', }}>
                                                <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                  Function
                                                </span>
                                                <span  >  :&nbsp;
                                                </span>
                                                <span style={{ width: '55%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{item.functionName}</span>
                                              </span>
                                              <span className=" mt-3" style={{ width: '33.4%', }}>
                                                <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                  Sub Function
                                                </span>
                                                <span  >  :&nbsp;
                                                </span>
                                                <span style={{ width: '55%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{item.subFunctionName}</span>
                                              </span>
                                            </div>

                                            <div style={{ fontSize: 14, width: "100%", }} className="ProductNameForRandM d-flex" >

                                              <span className=" mt-3" style={{ width: '33.4%', }}>
                                                <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                  Type Of Operation
                                                </span>
                                                <span  >  :&nbsp;
                                                </span>
                                                <span style={{ width: '55%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{item.typeOfOperationName}</span>
                                              </span>


                                              <span className=" mt-3" style={{ width: '33.4%', }}>
                                                <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                  {/* Required Date */}
                                                  Category
                                                </span>
                                                <span  >  :&nbsp;
                                                </span>
                                                <span style={{ width: '55%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{item.categoryName}</span>
                                              </span>



                                              {item.requesterRemarks !== "" ? (
                                                <span className=" mt-3" style={{ width: '33.4%', }}>
                                                  <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                    Requester Remarks
                                                  </span>
                                                  <span  >  :&nbsp;
                                                  </span>
                                                  <span style={{ width: '55%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{item.requesterRemarks}</span>
                                                </span>) : (
                                                ""
                                              )}
                                            </div>

                                            <div style={{ fontSize: 14, width: "100%", }} className="ProductNameForRandM d-flex" >
                                              <span className=" mt-3" style={{ width: '33.4%', }}>
                                                <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                  Required Date
                                                </span>
                                                <span  >  :&nbsp;
                                                </span>
                                                <span style={{ width: '55%', display: 'inline-flex', whiteSpace: "break-spaces" }}>{newDateFormat}</span>
                                              </span>

                                              <div className="mt-3" style={{ width: "33.4%" }}>
                                                <span style={{ width: "45%", display: "inline-block", fontWeight: 600 }}>
                                                  Estimated Date
                                                </span>
                                                <span>:&nbsp;</span>
                                                <span
                                                  style={{
                                                    width: "55%",
                                                    display: "inline-flex",
                                                    whiteSpace: "break-spaces",
                                                  }}
                                                >
                                                  <div style={{ width: "150px" }}>
                                                    <DatePicker
                                                      showIcon
                                                      className="form-control"
                                                      placeholderText="dd-mm-yyyy"
                                                      selected={estDate[index] ? new Date(estDate[index]) : null}
                                                      onChange={(date) => {
                                                        handleDateChange(
                                                          {
                                                            target: {
                                                              value: date
                                                                ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
                                                                : "",
                                                            },
                                                          },
                                                          index
                                                        );
                                                      }}
                                                      minDate={new Date(getCurrentDate())}
                                                      dateFormat="dd/MM/yyyy"
                                                      customInput={<CustomDatePickerInput style={{ width: "108px", height: "32px" }} />}
                                                    />
                                                  </div>
                                                </span>
                                              </div>

                                              <span className=" mt-3" style={{ width: '33.4%', }}>
                                                <span style={{ width: '45%', display: 'inline-block', fontWeight: 600 }} >
                                                  Acceptor Remarks
                                                </span>
                                                <span  >  :&nbsp;
                                                </span>
                                                <span style={{ width: '55%', display: 'inline-flex', whiteSpace: "break-spaces" }}>
                                                  <textarea
                                                    type="text"
                                                    style={{ borderColor: "silver", borderRadius: 5, }}
                                                    value={remark}
                                                    onChange={handleRemark} /></span>
                                                <div>
                                                  {errRemark && (
                                                    <span style={{ color: 'red', fontSize: '15px', display: 'block', marginTop: '5px' }}>
                                                      {errRemark}
                                                    </span>
                                                  )}
                                                </div>
                                              </span>

                                            </div>

                                            {errEstimated[index] && (
                                              <span
                                                style={{
                                                  color: "red",
                                                  fontSize: "15px",
                                                  display: "block",
                                                  marginTop: "4px",
                                                  marginLeft: "430px",
                                                }}
                                              >
                                                {errEstimated[index]}
                                              </span>
                                            )}

                                            <div>
                                              {
                                                <div
                                                  className="mt-4 d-flex"
                                                  style={{ gap: "8rem" }}
                                                >
                                                  <div className="w-50">
                                                    <span className="fw-bold">
                                                      {item.fertilizers.length >
                                                        0
                                                        ? "Fertilizers :"
                                                        : ""}
                                                    </span>

                                                    {item.fertilizers.length >
                                                      0 && (
                                                        <div className="d-flex justify-content-between mt-3">
                                                          <div className="d-flex flex-column">
                                                            <span className="custome-text-md fw-bold text-decoration-underline">
                                                              Name
                                                            </span>
                                                            {item.fertilizers.map(
                                                              (
                                                                fertilizer,
                                                                index
                                                              ) => (
                                                                <span
                                                                  key={index}
                                                                  className="custome-text-md font-weight-300 mt-2"
                                                                >
                                                                  {fertilizer.name ||
                                                                    "No Name"}
                                                                </span>
                                                              )
                                                            )}
                                                          </div>

                                                          <div className="d-flex flex-column">
                                                            <span className="custome-text-md fw-bold text-decoration-underline">
                                                              {/* Dosage */}
                                                              Quantity Used
                                                            </span>
                                                            {item.fertilizers.map(
                                                              (
                                                                fertilizer,
                                                                index
                                                              ) => (
                                                                <span
                                                                  key={index}
                                                                  className="custome-text-md font-weight-300 mt-2"
                                                                >
                                                                  {
                                                                    fertilizer.dosage
                                                                  }
                                                                </span>
                                                              )
                                                            )}
                                                          </div>
                                                        </div>
                                                      )}
                                                  </div>

                                                  <div className="w-50">
                                                    <span className="fw-bold">
                                                      {item.chemicals.length > 0
                                                        ? "Chemicals :"
                                                        : ""}
                                                    </span>

                                                    {item.chemicals.length >
                                                      0 && (
                                                        <div className="d-flex justify-content-between mt-3">
                                                          <div className="d-flex flex-column">
                                                            <span className="custome-text-md fw-bold text-decoration-underline">
                                                              Name
                                                            </span>
                                                            {item.chemicals.map(
                                                              (
                                                                chemical,
                                                                index
                                                              ) => (
                                                                <span
                                                                  key={index}
                                                                  className="custome-text-md font-weight-300 mt-2"
                                                                >
                                                                  {chemical.name ||
                                                                    "No Name"}
                                                                </span>
                                                              )
                                                            )}
                                                          </div>

                                                          <div className="d-flex flex-column">
                                                            <span className="custome-text-md fw-bold text-decoration-underline">
                                                              {/* Dosage */}
                                                              Quantity Used
                                                            </span>
                                                            {item.chemicals.map(
                                                              (
                                                                chemical,
                                                                index
                                                              ) => (
                                                                <span
                                                                  key={index}
                                                                  className="custome-text-md font-weight-300 mt-2"
                                                                >
                                                                  {
                                                                    chemical.dosage
                                                                  }
                                                                </span>
                                                              )
                                                            )}
                                                          </div>
                                                        </div>
                                                      )}
                                                  </div>
                                                </div>
                                              }
                                            </div>
                                            <span
                                              style={{}}
                                              className="d-flex justify-content-end mt-5"
                                            >
                                              <span>
                                                <button
                                                  className="btns"
                                                  onClick={() =>
                                                    handleApprove(index)
                                                  }
                                                  style={{ background: "var(--theme-bg-primary-color)", color: "#ffffff" }}
                                                >
                                                  Approve
                                                </button>
                                              </span>

                                              <span>
                                                <button
                                                  className="btnsReject ms-4"
                                                  onClick={() =>
                                                    handleModalOpen(item, index)
                                                  }
                                                >
                                                  Reject
                                                </button>
                                              </span>
                                            </span>
                                          </div>
                                        </Td>
                                      </Tr>
                                    )}
                                  </Tbody>
                                );
                              })
                            )}

                            {isLoading && (
                              <Loader
                                loading={isLoading}
                                message={"Fetching Data. Please Wait..!"}
                                loderimage={loaderImage}
                              />
                            )}
                          </Table>
                          <Pagination
                            currentPage={currentPage}
                            totalItems={sortedData.length}
                            itemsPerPage={itemsPerPage}
                            currentItems={currentItems}
                            onPageChange={handlePageClick}
                          />
                        </div>
                        <div>
                          <Modal
                            className="modalBlur"
                            show={showPopup}
                            onHide={handleCancel_new}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">Request </span>
                              </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p style={{ color: "#4A7729" }}>
                                    Are You Sure, Do You want close this Window
                                    ?
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleClose}
                                >
                                  Yes
                                </Button>
                                &nbsp;&nbsp;
                                <Button
                                  variant="danger"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleCancel}
                                >
                                  No
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>

                        <div>
                          <Modal
                            show={showResponsePopup}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">Request</span>
                              </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p style={{ color: "#4A7729" }}>
                                    {submitResponse}
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleresponse}
                                >
                                  Okay
                                </Button>
                                &nbsp;&nbsp;
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                      </div>
                    </div>
                  </div>
                  {loading && (
                    <div>
                      <p>Fetching data. Please wait...</p>
                      <Loader
                        height="80"
                        width="80"
                        radius="9"
                        color="#4A7729"
                        ariaLabel="loading"
                      />
                    </div>
                  )}
                </div>
                <div>
                  <Modal
                    show={showModal}
                    onHide={handleModalClose}
                    centered
                    backdrop="static"
                    keyboard={false}
                    size="md"
                  >
                    <Modal.Header className="border-0 d-flex justify-content-center">
                      <Modal.Title> </Modal.Title>

                      <Button
                        variant="link"
                        className="close btn btn-danger close_btn"
                        onClick={handleCancel_new}
                      >
                        X
                      </Button>
                    </Modal.Header>

                    <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                      <div className="d-flex justify-content-center mb-3 font-weight-600">
                        <span className="modal_title">Reject</span>
                      </div>
                      <div>
                        <div className="col-md-6 ">
                          <div className="mb-3">
                            <label
                              for="InputText"
                              className="form-label text-sm font-weight-600"
                            >
                              Remarks
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <textarea
                              className="form-control"
                              id="textAreaExample1"
                              rows="2"
                              value={remark}
                              onChange={handleRemark}
                            ></textarea>
                          </div>
                          <span style={{ color: "red" }}>{errRemark}</span>
                        </div>

                        <br />
                      </div>

                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <Button
                          variant="primary"
                          className="btnn"
                          onClick={() =>
                            handleReject(selectedItem, selectedItemIndex)
                          }
                        >
                          Submit
                        </Button>
                        <div style={{ width: "20px" }}></div>
                        <Button
                          variant="danger"
                          className="btnn"
                          onClick={handleClose}
                        >
                          Cancel
                        </Button>
                      </div>
                    </Modal.Body>
                  </Modal>
                </div>
                <div>
                  <Modal
                    show={showResponsePopup}
                    centered
                    backdrop="static"
                    keyboard={false}
                    size="ml"
                  >
                    <Modal.Header className="border-0 d-flex justify-content-center">
                      <Modal.Title>
                        {" "}
                        <span className="modal_title">Requests</span>
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                      <div className="d-flex justify-content-center mb-3 font-weight-600">
                        {showMsg ? (
                          <p style={{ color: "#4A7729" }}>{submitResponse}</p>
                        ) : null}
                      </div>
                      <div className="d-flex justify-content-center">
                        <Button
                          variant="primary"
                          className="d-flex justify-content-center cancel_button"
                          onClick={handleresponse}
                        >
                          Okay
                        </Button>
                        &nbsp;&nbsp;
                      </div>
                    </Modal.Body>
                  </Modal>
                </div>
              </div>
            </div>
          </div>
          {/* ...End of Main Content...*/}

          {/* ...Footer...*/}
          <Footer />
          {/* ... End of Footer...  */}
        </div>
      </div>
      {/*  <!-- End of Page Wrapper -->

                    <!-- Scroll to Top Button--> */}
      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>

      {/*  <!-- Logout Modal--> */}
      <Logout />
    </body>
  );
};

export default RequestFarmOperation1;
